module.exports = __webpack_public_path__ + "media/press/bloomberg-2c7b544b.png";